import React from 'react';
import { IconProps } from '../IconProps';

export const StatusPassIcon: React.FC<IconProps> = ({
	width = 24,
	height = 24,
	className,
}) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			viewBox="0 0 24 24"
			fill="none"
			className={className}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12C23.9923 5.37578 18.6242 0.00771476 12 0ZM18.927 8.2L12.082 17.489C11.9188 17.7056 11.6753 17.8475 11.4064 17.8829C11.1375 17.9182 10.8657 17.844 10.652 17.677L5.764 13.769C5.33267 13.4238 5.26282 12.7943 5.608 12.363C5.95318 11.9317 6.58267 11.8618 7.014 12.207L11.09 15.468L17.317 7.017C17.5212 6.71059 17.8773 6.54118 18.2438 6.57604C18.6104 6.61089 18.9281 6.84437 19.0709 7.18377C19.2137 7.52318 19.1584 7.91359 18.927 8.2Z"
				fill="#4A9912"
			/>
		</svg>
	);
};

export const StatusFailIcon: React.FC<IconProps> = ({
	width = 24,
	height = 24,
	className,
}) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			viewBox="0 0 24 24"
			fill="none"
			className={className}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12C23.9923 5.37578 18.6242 0.00771476 12 0ZM17.49 16.076C17.75 16.3271 17.8542 16.6989 17.7627 17.0485C17.6712 17.3981 17.3981 17.6712 17.0485 17.7627C16.6989 17.8542 16.3271 17.75 16.076 17.49L12.176 13.59C12.0779 13.4932 11.9201 13.4932 11.822 13.59L7.922 17.49C7.52883 17.8739 6.90117 17.8739 6.508 17.49C6.11762 17.0995 6.11762 16.4665 6.508 16.076L10.408 12.176C10.455 12.1293 10.4814 12.0658 10.4814 11.9995C10.4814 11.9333 10.455 11.8697 10.408 11.823L6.508 7.923C6.11781 7.53198 6.11848 6.89869 6.5095 6.5085C6.90052 6.11831 7.53381 6.11898 7.924 6.51L11.824 10.41C11.8709 10.457 11.9346 10.4834 12.001 10.4834C12.0674 10.4834 12.1311 10.457 12.178 10.41L16.078 6.51C16.3268 6.24003 16.7036 6.12813 17.0594 6.2185C17.4153 6.30888 17.693 6.58698 17.7829 6.94297C17.8728 7.29895 17.7603 7.67555 17.49 7.924L13.59 11.824C13.543 11.8707 13.5166 11.9342 13.5166 12.0005C13.5166 12.0667 13.543 12.1303 13.59 12.177L17.49 16.076Z"
				fill="#EB0A0A"
			/>
		</svg>
	);
};
